import React from 'react'
import PropTypes from 'prop-types'

import _ from 'lodash'

import AddCustomerEventDialog from './AddCustomerEventDialog'
import CommonRepository from 'billing/infra/CommonRepository'

export default class CustomerEventsSelector extends React.Component {

  static propTypes = {
    customerId: PropTypes.string,
    contactId: PropTypes.string,
    teamId: PropTypes.string.isRequired,
    onEventSelected: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      events: null,
      showCustomerEventsDialog: false
    }
  }

  componentDidMount() {
    this.addCustomerEventsListener(this.props)
  }

  componentWillUnmount() {
    this.removeCustomerEventsListener(this.props)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.customerId !== nextProps.customerId
      || this.props.contactId !== nextProps.contactId) {
      this.setState({ events: null })
      this.removeCustomerEventsListener(this.props)
      this.addCustomerEventsListener(nextProps)
    }
  }

  addCustomerEventsListener = props => {
    CommonRepository.addCustomerEventsListener(props.teamId,
      props.customerId, props.contactId, null, null, this.onCustomerEventsValue)
  }

  removeCustomerEventsListener = props => {
    CommonRepository.removeCustomerEventsListener(props.teamId,
      props.customerId, props.contactId, null, null, this.onCustomerEventsValue)
  }

  onCustomerEventsValue = snapshot => {
    const value = snapshot && snapshot.val() || {}
    this.setState({
      events: _.map(value)
    })
  }

  handleAddItemClicked = event => {
    event.preventDefault()
    if (this.props.customerId) {
      this.setState({
        showCustomerEventsDialog: true,
        anchorElement: event.currentTarget
      })
    }
  }

  handleCustomerEventDialogCloseRequested = () => {
    this.setState({
      showCustomerEventsDialog: false
    })
  }

  handleEventSelected = eventInfo => {
    this.props.onEventSelected(eventInfo)
    this.setState({
      showCustomerEventsDialog: false
    })
  }

  render() {
    return (
      <div style={styles.container}>
        <div style={styles.addEvent(this.props.customerId)} onClick={this.handleAddItemClicked}>
          <i className='material-icons' style={{ marginRight: 4 }}>add_circle</i> Add Job...
        </div>
        <AddCustomerEventDialog
          open={this.state.showCustomerEventsDialog}
          anchorElement={this.state.anchorElement}
          events={this.state.events}
          onCloseRequested={this.handleCustomerEventDialogCloseRequested}
          onEventSelected={this.handleEventSelected}/>
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
  },
  label: {
    marginBottom: 4
  },
  addEvent: customerId => ({
    display: 'flex',
    alignItems: 'center',
    cursor: customerId ? 'pointer' : 'not-allowed',
    fontSize: 14,
    color: '#356992',
    paddingTop: 0,
    paddingBottom: 0,
  })
}



// WEBPACK FOOTER //
// ./src/billing/invoices/modules/header/CustomerEventsSelector.js